import StepFour from "@/components/dashboard/buyCrypto/StepFour";

export default function BuyCryptoFour() {
  return <StepFour />;
}
